import { combineReducers } from 'redux';
import ChannelReducer from './channelReducer';
import Layout2Reducer from './layout2Reducer';

export default combineReducers({
	store: ChannelReducer,
	store2: Layout2Reducer
});